import { ChatStore } from "@/stores/ChatStore";

const MAX_MESSAGES = 50;

/** Chat snapshot for failed broker/claim analytics (no credentials). */
export function getChatSnapshotForAnalytics() {
  const { messages, sessionId } = ChatStore.getState();
  return {
    session_id: sessionId,
    messages: messages.slice(-MAX_MESSAGES).map((m) => ({
      role: m.sender,
      content: m.transcript,
      timestamp: m.timestamp instanceof Date ? m.timestamp.toISOString() : m.timestamp,
    })),
  };
}
